"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  id: "faq-1",
  question: "What marking does a UL 508A control panel need?",
  answer: "Typically an equipment nameplate with the panel's electrical ratings, field-wiring and warning markings, component identification, control legends, and a panel schedule; exact requirements depend on the panel and the applicable UL 508A provisions, which Evermark Industrial Solutions recommends confirming with the shop's UL program."
}, {
  id: "faq-2",
  question: "Does an Evermark nameplate make my panel UL 508A listed?",
  answer: "No — Evermark Industrial Solutions produces marking that aligns with UL 508A conventions when properly specified, but a panel's listing comes from the builder's own UL 508A program and the certifying body, not from the nameplate supplier."
}, {
  id: "faq-3",
  question: "Can Evermark match our nameplate format across every build?",
  answer: "Yes — Evermark Industrial Solutions stores approved layouts and reorders to the same proof, so repeat panels get identical marking in the same material and format."
}, {
  id: "faq-4",
  question: "Can you produce the arc flash labels too?",
  answer: "Yes — Evermark Industrial Solutions produces arc flash labels from the data in your arc flash study; Evermark makes the label and does not perform the study or determine the hazard values."
}, {
  id: "faq-5",
  question: "Do you set up recurring supply for panel shops?",
  answer: "Yes — Evermark Industrial Solutions sets up standing marking programs with locked-in layouts and materials for shops that build the same configurations repeatedly."
}];
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="faq" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="bg-muted/30 rounded-xl p-6 md:p-10 lg:p-12 shadow-sm border border-border/50">
            <div className="text-center mb-10">
              <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground tracking-tight">
                UL 508A Panel Labeling — Common Questions
              </h2>
            </div>

            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i}>
                  <AccordionTrigger className="text-base md:text-lg font-semibold text-foreground hover:text-primary transition-colors text-left">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-base leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}